export const breakpoints = {
    smallTablet: {
        width: 540,
        transforms: {
            quality: 'auto',
            crop: 'limit',
        },
    },
    mobile: {
        width: 375,
        transforms: {
            quality: 'auto',
            crop: 'limit',
        },
    },
};
